import React, { FC } from 'react';

import { EmptyStateImagesOld, Heading, Text, TextButton } from '../../../../../components/common';
import { FormattedMessage } from 'react-intl';

import styles from './NoResultsInCategory.scss';

interface NoResultsInCategoryProps {
  otherCategoriesTags: React.ReactNode;
  handleSearchAgainClick: () => void;
}

export const NoResultsInCategory: FC<NoResultsInCategoryProps> = ({ otherCategoriesTags, handleSearchAgainClick }) => (
  <div className={styles.topPart}>
    <div>
      <img src={EmptyStateImagesOld.MediaFromWix} alt="empty state" />
    </div>
    <div className={styles.texts}>
      <Heading size="large">
        <FormattedMessage id="empty-state.media-from-wix-no-results" />
      </Heading>
      <Text weight="normal" size="medium" className={styles.subTitle} tagName="div">
        <FormattedMessage
          id="empty-state.media-from-wix-no-results-subtitle-other-categories"
          values={{
            searchAgain: (
              <TextButton
                size="medium"
                onClick={handleSearchAgainClick}
                className={styles.searchAgain}
                dataHook="search-again"
              >
                <FormattedMessage id="empty-state.media-from-wix-no-results-subtitle-other-categories-search-again" />
              </TextButton>
            ),
          }}
        />
      </Text>
      <div className={styles.categories}>{otherCategoriesTags}</div>
    </div>
  </div>
);
